import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { CmsService } from 'src/app/core/services/cms.service';
import { MagoCloudService } from 'src/app/core/services/mago-cloud.service';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { EditionCode } from 'src/app/model/configuration';
import { YesNoDialogComponent } from 'src/app/store/dialogs/yes-no-dialog/yes-no-dialog.component';

@Component({
    selector: 'ms-editions-list',
    templateUrl: './editions-list.component.html',
    styleUrls: ['./editions-list.component.scss'],
})
export class EditionsListComponent implements OnInit {
    public updateSub = false;
    public createSub = false;
    public cmsObj: CmsObject[];
    public stdExplanation: string;
    public prmExplanation: string;
    public proExplanation: string;
    public entExplanation: string;

    @Output() oneEditionChange = new EventEmitter<string>();
    constructor(
        public magocloudService: MagoCloudService,
        private serviceUtilsService: ServiceUtilsService,
        public workflow: WorkFlowService,
        private variable: TranslatedVariables,
        public storeRolesService: StoreRolesService,
        private dialog: MatDialog,
        public cmsService: CmsService
    ) {}

    async ngOnInit() {
        await this.getCmsObj();
    }
    public async getCmsObj() {
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.workflow.getLanguageForCms(), 'industryAlaCarteConfigurator');

        this.stdExplanation = this.cmsObj.find((x) => x.ContentName == 'industryAlaCarteConfigurator.stdExplanation').ContentTranslation;

        this.prmExplanation = this.cmsObj.find((x) => x.ContentName == 'industryAlaCarteConfigurator.prmExplanation').ContentTranslation;

        this.proExplanation = this.cmsObj.find((x) => x.ContentName == 'industryAlaCarteConfigurator.proExplanation').ContentTranslation;

        this.entExplanation = this.cmsObj.find((x) => x.ContentName == 'industryAlaCarteConfigurator.entExplanation').ContentTranslation;
    }
    public async onClickEdition(editionCode: string, editionDescription: string) {
        this.magocloudService.edition = editionCode;
        //setto il numero minimo di cal acquistabili per quella edition
        this.magocloudService.currIndustryPurchInfo.OptionalFeatures = [];
        this.magocloudService.currIndustryPurchInfo.CountableFeatures = [];
        this.magocloudService.currIndustryPurchInfo.OptionalFeaturesOptionInfo = [];
        this.magocloudService.configurationService.optFeatureSelected = [];
        this.magocloudService.configurationService.optCountableFeatureSelected = [];
        this.magocloudService.configurationService.selectedOptionInfo = [];
        this.createSub =
            this.magocloudService.currIndustryPurchInfo.SubscriptionKey == undefined ||
            this.magocloudService.currIndustryPurchInfo.SubscriptionKey.length == 0;
        this.updateSub =
            this.magocloudService.currIndustryPurchInfo.SubscriptionKey &&
            this.magocloudService.currIndustryPurchInfo.SubscriptionKey.length > 0;
        if (
            this.magocloudService.currIndustryPurchInfo.Edition.EditionCode === editionCode &&
            this.magocloudService.currIndustryPurchInfo.Edition.EditionDescription === editionDescription
        ) {
            return;
        }

        let dlgAsk;
        if (
            this.magocloudService.currIndustryPurchInfo.SelectedFeaturesOptionInfo.length > 1 ||
            this.magocloudService.currIndustryPurchInfo.SelectedFeatures.length > 1
        ) {
            dlgAsk = this.dialog.open(YesNoDialogComponent, {
                data: {
                    Title: this.variable.changeEditionTitle,
                    Message: this.variable.changeEditionMessage,
                    //Result: true,
                    ShowDisableMe: false,
                },
            });

            dlgAsk.afterClosed().subscribe(async (resAskDlg) => {
                if (resAskDlg && resAskDlg.Result) {
                    this.magocloudService.edition = editionCode;
                    this.oneEditionChange.emit(editionCode);
                }
                return;
            });
        } else {
            this.magocloudService.edition = editionCode;
            this.oneEditionChange.emit(editionCode);
        }
    }
    getCorrectDescription(editionCode: string) {
        switch (editionCode) {
            case EditionCode.std:
                return this.stdExplanation;
            case EditionCode.prm:
                return this.prmExplanation;
            case EditionCode.pro:
                return this.proExplanation;
            case EditionCode.ent:
                return this.entExplanation;
        }
    }
}
